import { useOneButtonStore } from '../store/oneButtonStore';
import { useViewerStore } from '../store/store';

/** Contacts split modal is open on top of the oneBUTTON dashboard. */
export function isDashboardContactsModalOpen(): boolean {
    return useOneButtonStore.getState().dashboardContactsModalOpen;
}

/** Full oneBUTTON dashboard shell is visible (viewer may be behind it). */
export function isOneButtonDashboardOpen(): boolean {
    return Boolean((useViewerStore.getState() as { isDashboardOpen?: boolean }).isDashboardOpen);
}

/**
 * Suppress full-screen viewer loading overlays while the user is on the dashboard UI
 * (including the contacts modal). Inline spinners on explicit actions still show.
 */
export function shouldSuppressViewerLoadingOverlays(): boolean {
    return isDashboardContactsModalOpen() || isOneButtonDashboardOpen();
}

/**
 * Block background Tree Calculator / ghost-scenario work while the user is editing
 * contacts or browsing the dashboard without an explicit Run AI in progress.
 */
export function shouldDeferBackgroundTreeCalculatorWork(): boolean {
    if (isDashboardContactsModalOpen()) return true;
    if (!isOneButtonDashboardOpen()) return false;
    const state = useViewerStore.getState() as { aiLoading?: boolean; reRunningTreeScenarios?: boolean };
    // Run AI / explicit tree re-run flip these flags before calling the calculator.
    return !state.aiLoading && !state.reRunningTreeScenarios;
}
